<template>
    <div>
        <div class="item-inner item-sp">
            <div class="item-title-row">
                <div class="item-title" v-if="specialBooking.specialBookingType==1" @click="showSpecialBookingPopup">
                    <img class="item-icon" src="https://resource.rcclchina.com.cn/wechatMiniProgram/WechatMiniProgramImage/birthdayRoom/birthday_icon.png" />
                    <span>付费生日礼遇</span>
                    <img class="item-click" src="https://resource.rcclchina.com.cn/RcclHP/icon08.png">
                </div>
                <div class="item-after" @click="showSelector">
                    <div class="sp-guests" v-if="selectedGuests.length==0">暂不选择</div>
                    <div class="sp-guests-select" v-else>修改/取消生日礼遇</div>
                    <i class="f7-icons">right</i>
                </div>
            </div>
            <div class="item-content" v-if="selectedGuests.length>0">
                <div class="item-selected-content">
                    <div>已选择<span>{{selectedGuestName}}</span>享受生日礼遇</div>
                    <div>
                        将于<span>{{selectedDate}} 晚餐 {{selectedPlace}}</span>享用生日蛋糕
                    </div>
                </div>
            </div>
          <div class="item-discounts">
              <span class="discounts-right">限时优惠：</span>{{ specialBooking.price || 0 }}元/人(建议价<span class="discounts-left">800元</span>)；
          </div>
        </div>

        <guest-info-special-booking-select 
            v-if="isShowSelect"
            :isShow="isShowSelect"
            :specialBooking="specialBooking"
            :mealInfoViews="mealInfoViews"
            :guests="guests"
            :couponCode="couponCode"
            :sessionToken="sessionToken"
            :onClose="closeSelector"
        />

        <special-booking-rule-image-popup
            :specialRuleImage="specialBookingRuleImage"
            :closeSpecialBookingPopup="closeSpecialBookingPopup"
            v-show="isShowSpecialBookingRuleImagePopup"
            :specialName="specialBookingName"
            />
    </div>

    
</template>

<script>
const GuestInfoSpecialBookingSelect = () => import('@/components/Booking/GuestInfoSpecialBookingSelect')
const SpecialBookingRuleImagePopup = () => import('@/components/Cruise/SpecialBookingRuleImagePopup')
import { SpecialBookingType } from '@/utilities/specialBookingHelper'
export default {
    components: { 
        GuestInfoSpecialBookingSelect,
        SpecialBookingRuleImagePopup
    },
    name: "GuestInfoSpecialBooking",
    props: {
        specialBookingInfo: {
            type: Object,
            default () {
                return {}
            }
        },
        booking: {
            type : Object,
            default () {
                return {}
            }
        }
        
    },
    data () {
        return {
            isShowSelect: false,
            isShowSpecialBookingRuleImagePopup: false
        }
    },
    mounted () {

    },
    beforeDestroy () {
        window.onpopstate = ()=>{}
    },
    methods: {
        closeSelector () {
            this.isShowSelect = false
        },
        showSelector () {
            let completedGuests = this.guests.filter(r=>r.pyLastName && r.pyLastName.length > 0
             && r.pyFirstName && r.pyFirstName.length > 0
             && r.birthDate && r.birthDate.length > 0)
            if (completedGuests.length < this.booking.guestNumber) {
                this.$alert.show('请先添加乘客信息！')
            } else {
                this.isShowSelect = true
            }
        },
        showSpecialBookingPopup () {
            this.isShowSpecialBookingRuleImagePopup = true
        },
        closeSpecialBookingPopup () {
            this.isShowSpecialBookingRuleImagePopup = false
        },
        showPopup() {
            history.pushState({ page: 'guestInfo' }, null);
        },
    },
    computed: {
        guests() {
            if (this.booking.guests && this.booking.guests.guestPersons) {
                return this.booking.guests.guestPersons
            }
            return []
        },
        sessionToken () {
            return this.booking.sessionToken
        },
        couponCode () {
            return this.booking.couponCode
        },
        specialBookings () {
            return this.specialBookingInfo.specialBookingViewModels || []
        },
        specialBooking () {
            return this.specialBookings.length == 0 ? {}: this.specialBookings[0]
        },
        specialBookingRuleImage () {
            return this.specialBooking.mobileRuleDescriptionImage || ""
        },
        specialBookingName () {
            if (this.specialBooking.specialBookingType == SpecialBookingType.Birthday) {
                return "皇家生日礼遇"
            }
            return ""
        },
        mealInfoViews () {
            return this.specialBookingInfo.mealInfoViews || []
        },
        selectedGuests () {
            return this.guests
                .filter(r=>r.specialBookingOrder 
                && r.specialBookingOrder.specialBookingType == this.specialBooking.specialBookingType)
        },
        selectedGuestName () {
            let names = []
            this.selectedGuests.forEach(guest=> {
                let name = guest.lastName + guest.firstName
                if (!name || name.trim().length == 0) {
                    name = `${guest.pyLastName} ${guest.pyFirstName}`
                }
                names.push(name)
            })
            return names.join('、')
        },
        selectedDate () {
            if (this.selectedGuests.length > 0) {
                return this.selectedGuests[0].specialBookingOrder.specialBookingDate
            }
            return ""
        },
        selectedTimeslot () {
            let timeslot = 0
            if (this.selectedGuests.length > 0) {
                timeslot = this.selectedGuests[0].specialBookingOrder.specialBookingTimeslot
                let mealInfo = this.mealInfoViews.find(r=>r.mealTimeType == timeslot)
                return mealInfo ? mealInfo.mealTime : ""
            }
            return ""
        },
        selectedPlace () {
            let place = 0
            if (this.selectedGuests.length > 0) {
                place = this.selectedGuests[0].specialBookingOrder.specialBookingPlace
                let mealInfo = this.mealInfoViews.find(r=>r.mealPlaceType == place)
                return mealInfo ? mealInfo.mealPlace : ""
            }
            return ""
        }
    }
}
</script>

<style lang="less" scoped>
.item-inner.item-sp {
    margin: 15px -12px 0px;
    width: auto;
    border-top: solid 1px rgba(229, 229, 229, 0.6);
    border-bottom: solid 1px rgba(229, 229, 229, 0.6);
    padding: 0px;
    min-height: auto;
    padding-bottom: 10px;
    .item-title-row {
        padding: 10px 12px 0px;
    }
    .item-discounts{
      height: 20px;
      margin: 11px 12px 0 12px;
      background: rgba(243, 61, 15, 0.15);
      font-size: 9px;
      padding-left: 7px;
      line-height: 20px;
      color: #4A4A4A;
      .discounts-right{
        color: #FE0000;
      }
      .discounts-left{
        text-decoration: line-through;
      }
    }
}
.item-title {
    img.item-icon {
        width: 19px;
        display: inline-block;
        vertical-align: middle;
        margin-right: 5px;
    }
    img.item-click {
        width: 12px;
        display: inline-block;
        vertical-align: middle;
        margin-left: 5px;
    }
    span {
        display: inline-block;
        vertical-align: middle;
        font-size: 12px;
        color: #4A90E2;
        font-weight: normal;
        letter-spacing: 0;
        vertical-align: middle;
    }
}
.item-after {
    font-size: 0.6rem;
    font-weight: normal !important;
    position: relative;
    top: 3px;
    .f7-icons {
        color: #0071a3;
    }
    .sp-guests {
        display: inline-block;
        vertical-align: middle;
        color: #ABABAB;
    }
    .sp-guests-select {
        font-size: 12px;
        color: #000;
    }
}

.item-content {
    padding-left: 35px;
    padding-bottom: 0px;
    min-height: initial;
    font-size: 11px;
    color: #4A4A4A;
    display: block;
    .item-selected-content {
        display: block;
        >div {
            margin-top: 5px;
        }
        span {
            color: #000;
            text-decoration: underline;
            margin: 0px 5px;
        }
    }
    
}
</style>